<script lang="ts">
    import { Route, Router } from 'yrv'
    import Ztab from '../_common/z/ztab.svelte'
    import PartnersPartners from './partners-partners.svelte'
    import PartnersReferrals from './partners-referrals.svelte'
    import PartnersEntries from './partners-entries.svelte'

    let tabs = [
        {
            title: 'Parceiros',
            url: '/partners/home',
        },
        {
            title: 'Indicados',
            url: '/partners/referrals',
        },
        {
            title: 'Extrato',
            url: '/partners/entries',
        },
    ]
</script>

<div class="">
    <Ztab class="h-space" {tabs} />
    <Router>
        <Route path="/home">
            <PartnersPartners></PartnersPartners>
        </Route>
        <Route path="/referrals">
            <PartnersReferrals></PartnersReferrals>
        </Route>
        <Route path="/entries">
            <PartnersEntries></PartnersEntries>
        </Route>
    </Router>
</div>
